// const axios = require('@/utils/axios')
// const {baseURL} = require('@/assets/js/config')
// const $http = axios.create({
// 	baseURL
// })
let emptyAnswerState = {
	options: [],
	divider: [],
	custom_layout: {},
	pattern: {
		current_button: null,
		current: {
			layer_index: null,
			col_index: null,
		},
		layers: {},
	},
	dq: "",
	tf: null,
	number_line: null,
	drag_drop: null,
	tables: {
		data: {},
		clicked: {},
	},
	matching: null,
	line_chart: null,
	venn_diagram: null,
	protractor: null,
	bar_chart: null,
	drag_box: null,
	color_grid: null,
	grid_translator: null,
	cut_spinner: null,
	angle_lines: null,
	clipart_table: null,
	line_creator: null,
}

const state = {
	current_question_index: 0,
	emptyAnswerState : JSON.parse(JSON.stringify(emptyAnswerState)),
	current_answer : JSON.parse(JSON.stringify(emptyAnswerState))
}

const getters = {
	fetchCurrentQuestionIndex: (state) => state.current_question_index,
	fetchEmptyAnswerState : (state) => state.emptyAnswerState,
	fetchCurrentAnswer : (state) => state.current_answer
}

const actions = {
	updateCurrentQuestionIndex({ commit }, index) {
		commit('SET_CURRENT_QUESTION_INDEX', index)
	},
	updateCurrentAnswer({commit}, data){
		commit('UPDATE_CURRENT_ANSWER', data)
	},
	initializeCurrentAnswer({commit}){
		commit('INITIALIZE_CURRENT_ANSWER')
	}
}

const mutations = {
	SET_CURRENT_QUESTION_INDEX: (state, index) => {
		state.current_question_index = index
	},
	UPDATE_CURRENT_ANSWER: (state, data) => {
		state.current_answer = {
			...state.current_answer,
			[data.key] : data.value
		}
	},
	INITIALIZE_CURRENT_ANSWER : (state) => {
		state.current_answer = JSON.parse(JSON.stringify(state.emptyAnswerState))
	}
}

export default {
	state, getters, actions, mutations
}